module.exports = __webpack_public_path__ + "cdf01e824be8a9614ed9c59791866061.fbx";